import {
  COMMERCIAL_OPERATION_TYPE_LABELS,
  type CommercialOperationType,
} from '@/modules/commercial/types';

const TYPE_CLASS: Record<CommercialOperationType, string> = {
  quotation: 'commercial-type--quotation',
  rental: 'commercial-type--rental',
  sale: 'commercial-type--sale',
};

type CommercialTypeBadgeProps = {
  type: CommercialOperationType;
};

export function CommercialTypeBadge({ type }: CommercialTypeBadgeProps) {
  return (
    <span className={`commercial-type ${TYPE_CLASS[type]}`}>
      {COMMERCIAL_OPERATION_TYPE_LABELS[type]}
    </span>
  );
}
